var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getActiveJourney)?_c('div',[_vm._l((_vm.limits),function(limit){return _c('here-info-bubble',{key:limit.id,attrs:{"name":"test-bubble","lat":limit.latitude,"lng":limit.longitude,"component":_vm.speedInfoBubble,"data":{
            speed: _vm.calculateSpeed(limit.speed),
            heading: limit.heading,
            date: limit.date,
            hardwareId: limit.hardwareId,
            latitude: limit.latitude,
            longitude: limit.longitude,
            registrationNumber: limit.registrationNumber || 'Unknown',
            driverName: limit.driverName || 'Unknown',
            status: limit.status,
            hasStreamingDevice: _vm.deviceList.includes(limit.hardwareId),
            hasRequestVideoPermissions: _vm.hasAllRoles(['VideoRequests']) && _vm.checkMediaAccessibilityLicense(),
        }}},[_c('here-marker',{attrs:{"lat":limit.latitude,"lng":limit.longitude,"icon":{
                bitmap: _vm.invisibleIcon,
                size: { w: 35, h: 35 },
                options: { anchor: { x:15, y: 0 } },
                hitArea: _vm.hitArea
        }}})],1)}),_vm._l((_vm.getActiveJourney.events),function(event){return _c('here-info-bubble',{key:event.id,attrs:{"name":"event-bubble","lat":event.locations[0].lat,"lng":event.locations[0].lng,"component":_vm.eventInfoBubble,"data":{
            event: event,
            eventTypes: _vm.getEventTypes
        }}},[(event.isVisible)?_c('here-marker',{key:event.id,attrs:{"lat":event.locations[0].lat,"lng":event.locations[0].lng,"icon":{
                    bitmap: _vm.iconsEvent
                },"map":_vm.map}}):_vm._e()],1)}),(_vm.startAndStopPoints.length)?_c('div',{staticClass:"start-and-stop-wrapper"},_vm._l((_vm.startAndStopPoints),function(point){return _c('here-marker',{key:point.utcTimestamp,attrs:{"lat":point.location.lat,"lng":point.location.lng,"icon":{
                    bitmap: point.type === 'start' ? _vm.iconsStart : _vm.iconsEnd
                },"map":_vm.map}})}),1):_vm._e(),_c('here-polyline',{attrs:{"points":_vm.dataLines,"with-arrows":""}})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }